import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsSchemesEntityRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-schemes-entity',
	path: '/secure/admin/ViewEditFieldLayoutSchemeEntity([!%]?[\\w]*).jspa',
};
